import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { ModeService } from '@lp/services/mode';
import { AuthService } from '@lp/services/auth';
import { filter, map, catchError } from 'rxjs/operators';
import { Observable, of, take } from 'rxjs';
import { APP_ROUTES } from '@lp/routes';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';

export const modeAvailableGuard: CanActivateFn = (route): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const modeService = inject(ModeService);
  const auth = inject(AuthService);
  const broadcast = inject(MsalBroadcastService);
  const mode = route.params['mode'];

  if (!mode) {
    console.warn('[ModeGuard] Mode parameter missing, redirecting to chat.');
    return of(router.parseUrl(APP_ROUTES.chat));
  }

  return broadcast.inProgress$.pipe(
    filter((status) => status === InteractionStatus.None),
    take(1),
    map(() => auth.roles.length > 0),
    take(1),
    map(() => {
      const match = modeService.availableModes.some((m) => m === mode);

      if (!match) {
        console.warn(`[ModeGuard] Mode "${mode}" not available after checking roles, redirecting to not-found.`);
        return router.parseUrl('/not-found');
      }
      return true;
    }),
    catchError((error) => {
      console.warn('[ModeGuard] Error during role check or mode validation:', error);
      return of(router.parseUrl(APP_ROUTES.error));
    })
  );
};
